import * as React from "react";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InstrumentSelection } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { processTypeEnum } from "../../Resource/Contents";
import { DocumentsToSend } from "./DocumentsToSend";
import { InvestmentDocuments } from "./InvestmentDocuments";
import { QuoteAndCharges } from "./QuoteAndCharges";

interface IDocumentsProps extends IProcessComponentProps {
    data:
        | ApplyModel
        | GiaContributionModel
        | IsaContributionModel
        | PensionContributionModel
        | WrapCashContributionModel;
    processType: processTypeEnum;
    subAccountType: SubAccountType;
    needGoToDlu: boolean;
    clAccountId?: string;
    onTasksForEsign: (newTask) => void;
}

interface IDocuments {
    selectAll: boolean;
    triggerred: number;
}

export class Documents extends ProcessComponent<IDocumentsProps, IDocuments> {
    constructor(props: IDocumentsProps) {
        super(props);
        this.state = {
            selectAll: false,
            triggerred: 0,
        };
    }

    render() {
        const showMsg =
            this.props.processType == processTypeEnum.NewBusiness ||
            this.props.processType == processTypeEnum.NewBusinessExistingClient;
        return (
            <>
                <h2>Documents</h2>
                {showMsg && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            "The section below will include the relevant documents for the products and investments that have been chosen.  If your client is investing in a SIPP or Bond, more documents will be available later in the journey."
                        }
                    />
                )}
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Select all documents",
                            disabled: this.props.isReview,
                            value: this.state.selectAll,
                            onChange: (v) => {
                                this.setState({ selectAll: v });
                            },
                        },
                    ]}
                />
                <QuoteAndCharges
                    {...this.props}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                    onRef={(ref) => this.appendChild(ref)}
                />
                <DocumentsToSend
                    {...this.props}
                    onRef={(ref) => this.appendChild(ref)}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                    onTasksForEsign={(val) => this.props.onTasksForEsign(val)}
                    readonly={false}
                    isReview={false}
                />
                <InvestmentDocuments
                    {...this.props}
                    onRef={(ref) => this.appendChild(ref)}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                />
                <div>
                    <button
                        className="btn primary"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState({ triggerred: this.state.triggerred + 1, selectAll: false });
                        }}
                    >
                        Generate document(s)
                    </button>
                </div>
            </>
        );
    }
}
